import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { FAQ_GROUPS } from "@/data/faqs";
import { SectionHeading, Breadcrumbs, CTABand } from "@/components/Shared";
import { Seo, breadcrumbSchema, faqPageSchema } from "@/components/Seo";

export default function FAQs() {
  let counter = 0;
  const allFaqs = FAQ_GROUPS.flatMap((g) => g.faqs);
  return (
    <div data-testid="faqs-page">
      <Seo
        title="ENT Surgery FAQs — Safety, Recovery & Costs | Dr. Sanjay Teza, Varanasi"
        description="Answers to common ENT surgery questions on indications, safety, anaesthesia, recovery, risks, hospitalisation, costs and myths — from Dr. Sanjay Teza, senior ENT surgeon in Varanasi."
        path="/faqs"
        schemas={[
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Surgery FAQs", path: "/faqs" },
          ]),
          faqPageSchema(allFaqs),
        ]}
      />
      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Surgery FAQs" }]} />
          <div className="mt-6">
            <SectionHeading
              eyebrow="ENT Surgery FAQs"
              title="Answers to Your ENT Surgery Questions"
              subtitle="Honest, evidence-based answers on indications, safety, anaesthesia, recovery, risks, hospitalisation, costs and common myths — so you can make an informed decision."
            />
          </div>
        </div>
      </section>

      <section className="bg-brand-bg">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
          {FAQ_GROUPS.map((group) => (
            <div
              key={group.category}
              className="mb-10 last:mb-0"
              data-testid={`faq-group-${group.category.toLowerCase().replace(/[\s&]+/g, "-")}`}
            >
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-brand-primary text-white">
                  <HelpCircle className="h-5 w-5" />
                </span>
                <h2 className="font-heading text-xl font-bold text-brand-ink">
                  {group.category}
                </h2>
              </div>
              <Accordion
                type="single"
                collapsible
                className="mt-4 rounded-lg border border-brand-line bg-white px-6"
              >
                {group.faqs.map((f) => {
                  const idx = counter++;
                  return (
                    <AccordionItem
                      key={idx}
                      value={`q-${idx}`}
                      className="border-brand-line last:border-0"
                    >
                      <AccordionTrigger
                        data-testid={`faq-trigger-${idx}`}
                        className="text-left font-heading text-base font-semibold text-brand-ink hover:text-brand-primary hover:no-underline"
                      >
                        {f.q}
                      </AccordionTrigger>
                      <AccordionContent className="text-sm leading-relaxed text-brand-slate">
                        {f.a}
                      </AccordionContent>
                    </AccordionItem>
                  );
                })}
              </Accordion>
            </div>
          ))}
        </div>
      </section>

      <CTABand
        title="Still have a question?"
        subtitle="Message Dr. Sanjay Teza directly on WhatsApp — your queries about ENT surgery will be answered clearly."
        whatsappText="Hello Dr. Sanjay Teza, I have a question about ENT surgery."
      />
    </div>
  );
}
